<template>
    <div class="row">
        <div class="position-relative w-100 p-2">
            <h4 class="py-3">SOAP Notes</h4>

            <div class="p-2 mb-3 widget">
                <h5>Create new note</h5>
                <div class="row">
                    <div class="col-3">
                        <p class="mb-0   text-uppercase">Subjective</p>
                        <textarea
                            class="form-control form-control-sm"
                            v-model="newPayload.subjective"
                            name="description"
                            id="selective"
                            rows="3"
                            placeholder="What the parent or child if they are old enough said how they are feeling"
                        ></textarea>
                    </div>

                    <div v-if="!newPayload.is_objective_assessment_combined" class="col-6 col-sm-3">
                        <p class="mb-0   text-uppercase">Objective</p>
                        <textarea
                            class="form-control form-control-sm"
                            v-model="newPayload.objective"
                            name="description"
                            id="objective"
                            rows="3"
                            placeholder="What you did during session"
                        ></textarea>
                    </div>

                    <div v-if="!newPayload.is_objective_assessment_combined" class="col-6 col-sm-3">
                        <p class="mb-0   text-uppercase">Assessment</p>
                        <textarea
                            class="form-control form-control-sm"
                            v-model="newPayload.assessment"
                            name="description"
                            id="assessment"
                            rows="3"
                            placeholder="How the child responded to the Objective"
                        ></textarea>
                    </div>

                    <div v-if="newPayload.is_objective_assessment_combined" class="col-6 col-sm-3">
                        <p class="mb-0   text-uppercase">Objective & Assessment</p>
                        <textarea
                            class="form-control form-control-sm"
                            v-model="newPayload.objective"
                            name="description"
                            id="objective_assessment"
                            rows="3"
                            placeholder="The Objective is what you did during session and the Assessment is how the child responded to the Objective"
                        ></textarea>
                    </div>

                    <div class="col-6 col-sm-3">
                        <p class="mb-0   text-uppercase">Plan</p>
                        <textarea
                            class="form-control form-control-sm"
                            v-model="newPayload.plan"
                            name="description"
                            id="plan"
                            rows="3"
                            placeholder="What is the plan for the next therapy visit"
                        ></textarea>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 col-lg-3">
                        <p class="mb-0   text-uppercase">Date</p>
                        <v-date-picker
                            id="date"
                            class="picker-container"
                            popover-align="left"
                            v-model="newPayload.session_at"
                        ></v-date-picker>
                    </div>
                    <div class="col-6 col-lg-3">
                        <custom-signature
                            ref="caregiverSignature"
                            @cancel="caregiverSignatureCancelled"
                            @created="caregiverSignatureCreated"
                            :canvas-id="'tracker-soap-caregiver-sig'"
                            :name="'Caregiver'"
                        ></custom-signature>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="my-2 w-100 d-flex justify-content-between">
                            <div>
                                <input
                                    class=""
                                    v-model="newPayload.is_objective_assessment_combined"
                                    type="checkbox"
                                    value=""
                                    id="consecutive"
                                />
                                <label class="" for="consecutive">
                                    <small>
                                        Merge Objective and Assessment fields
                                    </small>
                                </label>
                            </div>

                            <button
                                id="save-note"
                                class="btn btn-sm btn-primary text-white text-uppercase font-weight-bold"
                                @click="saveNote()"
                            >
                                Create note
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <paginator :pagination="pagination" @fetch="setPage($event)"></paginator>

            <div class="row">
                <div class="col-12">
                    <div style="border: solid 1px #8f8f8f;">
                        <div class="row mx-0 px-2" style="background-color: #323336">
                            <div class="col-1 px-1">
                                <small class="text-uppercase text-white">Date</small>
                            </div>
                            <div class="col-2 px-1">
                                <small class="text-uppercase text-white">Subjective</small>
                            </div>
                            <div class="col-2 px-1">
                                <small class="text-uppercase text-white">Objective</small>
                            </div>
                            <div class="col-2 px-1">
                                <small class="text-uppercase text-white">Assessment</small>
                            </div>
                            <div class="col-2 px-1">
                                <small class="text-uppercase text-white">Plan</small>
                            </div>
                            <div class="col-2 px-1 d-none d-lg-flex">
                                <small class="text-uppercase text-white">Signatures</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-3" id="soap_chart">
                <div class="col-12">
                    <div class="row mx-0 px-2 data-row" v-for="(note, index) in paginatedNotes">
                        <div
                            class="col-1 px-1 d-flex flex-column align-items-start align-items-center"
                        >
                            <v-date-picker
                                v-if="isEditing(note.id)"
                                id="date"
                                class="picker-container"
                                popover-align="left"
                                v-model="payload.session_at"
                            ></v-date-picker>
                            <span v-else="" class="small">
                                {{ moment(note.session_at).format("MM/DD/YYYY") }}
                            </span>
                            <profile-picture
                                v-if="note.author_profile_photo_url"
                                :name="note.author_name"
                                :size="'sm'"
                                :url="note.author_profile_photo_url"
                            ></profile-picture>
                        </div>
                        <div class="col-2 px-1">
                            <textarea
                                class="form-control form-control-sm"
                                v-if="isEditing(note.id)"
                                v-model="payload.subjective"
                                rows="7"
                                @input="setdataEntered(note.id)"
                            ></textarea>
                            <span v-else="" class="small">
                                {{ note.subjective }}
                            </span>
                        </div>
                        <div class="col-2 px-1">
                            <textarea
                                class="form-control form-control-sm"
                                v-if="isEditing(note.id)"
                                v-model="payload.objective"
                                rows="7"
                                @input="setdataEntered(note.id)"
                            ></textarea>
                            <span v-else="" class="small">
                                {{ note.objective }}
                            </span>
                        </div>
                        <div class="col-2 px-1">
                            <textarea
                                class="form-control form-control-sm"
                                v-if="isEditing(note.id)"
                                v-model="payload.assessment"
                                rows="7"
                                @input="setdataEntered(note.id)"
                            ></textarea>
                            <span v-else="" class="small">
                                {{ note.assessment }}
                            </span>
                        </div>
                        <div class="col-2 px-1">
                            <textarea
                                class="form-control form-control-sm"
                                v-if="isEditing(note.id)"
                                v-model="payload.plan"
                                rows="7"
                                @input="setdataEntered(note.id)"
                            ></textarea>
                            <span v-else="" class="small">
                                {{ note.plan }}
                            </span>
                        </div>
                        <div class="d-none d-lg-flex col-2 px-1 ">
                            <v-popover
                                v-if="note.caregiver_signature"
                                offset="16"
                                defaultTrigger="hover"
                                popoverClass="popover-container-signature"
                                trigger="hover"
                            >
                                <span class="btn-link tooltip-target b3">Caregiver</span>

                                <template slot="popover">
                                    <img
                                        style="width:100%"
                                        :src="`${note.caregiver_signature}`"
                                        alt=""
                                    />
                                    <span class="caregiver-signature-date">{{
                                        moment(note.created_at).format("MM/DD/YYYY HH:mm:ss")
                                    }}</span>
                                </template>
                            </v-popover>
                        </div>
                        <div class="px-1 pt-1 col-3 col-lg-1 text-right">
                            <template>
                                <div
                                    class="btn-group"
                                    role="group"
                                    aria-label="Main action and dropdown"
                                >
                                    <button
                                        type="button"
                                        :id="`action-${note.id}`"
                                        class="btn btn-sm btn-primary"
                                        :disabled="
                                            !(
                                                canEditClientEmr ||
                                                patientIsAssignedToCurrentTherapist
                                            )
                                        "
                                        style="width: 3.25rem;"
                                        @click="
                                            isEditing(note.id)
                                                ? dataEntered
                                                    ? updateNote()
                                                    : cancelEdit()
                                                : edit(note)
                                        "
                                    >
                                        {{
                                            isEditing(note.id)
                                                ? dataEntered
                                                    ? "Update"
                                                    : "Cancel"
                                                : "Edit"
                                        }}
                                    </button>
                                    <div class="btn-group" role="group">
                                        <button
                                            id="dropdown"
                                            type="button"
                                            class="btn btn-sm btn-primary dropdown-toggle"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                        ></button>
                                        <div
                                            class="dropdown-menu dropdown-menu-right"
                                            aria-labelledby="dropdown"
                                        >
                                            <a
                                                class="cursor-pointer dropdown-item small"
                                                v-if="isEditing(note.id)"
                                                @click.prevent="
                                                    dataEntered === note.id
                                                        ? cancelEdit()()
                                                        : updateNote()
                                                "
                                            >
                                                {{ dataEntered === note.id ? "Cancel" : "Update" }}
                                            </a>
                                            <a
                                                class="cursor-pointer dropdown-item small text-danger"
                                                :disabled="!canAddClient"
                                                @click.prevent="deleteNote(note.id)"
                                                >Delete</a
                                            >
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <paginator :pagination="pagination" @fetch="setPage($event)"></paginator>
        </div>
    </div>
</template>

<script>
import GoalsExportSoap from "../goals/GoalsExportSoap.vue";
import PatientOverview from "./PatientOverview";
import PatientAssessment from "./PatientAssessment";
import PatientAlerts from "./PatientAlerts";
import PatientUpdates from "./PatientUpdates";
import ProfilePicture from "../ui/ProfilePicture";
import { permissions } from "../../plugins/permissions";
import { fixDatePickers } from "../../plugins/fixDatePickers";
import { helpers } from "../../plugins/helpers";
import { pagination } from "../../plugins/pagination";
import CustomSignature from "../ui/CustomSignature.vue";

export default {
    name: "SoapNotes",
    props: ["patient", "userId"],
    mixins: [fixDatePickers, permissions, pagination],
    components: {
        CustomSignature,
        GoalsExportSoap,
        PatientOverview,
        PatientAssessment,
        PatientAlerts,
        PatientUpdates,
        ProfilePicture,
    },

    data() {
        return {
            notes: [],
            payload: {
                id: null,
                subjective: null,
                objective: null,
                assessment: null,
                plan: null,
                session_at: new Date(),
                patient_id: null,
                created_by_user_id: null,
                is_signed: false,
                caregiver_signature: null,
                is_objective_assessment_combined: false,
            },
            newPayload: {
                id: null,
                subjective: null,
                objective: null,
                assessment: null,
                plan: null,
                session_at: new Date(),
                patient_id: null,
                created_by_user_id: null,
                is_signed: false,
                caregiver_signature: null,
                is_objective_assessment_combined: false,
            },
            dataEntered: null,
        };
    },

    created() {
        this.fetchNotes();
    },

    computed: {
        patientIsAssignedToCurrentTherapist() {
            return _.get(this.patient, "therapists", [])
                .map(therapist => therapist.id)
                .includes(this.userId);
        },

        paginatedNotes() {
            return this.notes.filter((note, index) => {
                return (
                    index >= (this.pagination.current_page - 1) * this.pagination.per_page &&
                    index < this.pagination.current_page * this.pagination.per_page
                );
            });
        },
    },

    methods: {
        resetPayload() {
            this.dataEntered = null;
            (this.payload = {
                id: null,
                subjective: null,
                objective: null,
                assessment: null,
                plan: null,
                session_at: new Date(),
                patient_id: null,
                created_by_user_id: null,
                is_signed: false,
                caregiver_signature: null,
                is_objective_assessment_combined: false,
            }),
                (this.newPayload = { ...this.payload });
        },

        cancelEdit() {
            this.resetPayload();
        },

        setdataEntered(id) {
            this.dataEntered = id;
        },

        isEditing(id) {
            return this.payload.id && this.payload.id === id;
        },

        edit(note) {
            setTimeout(this.removePickerMinWidth, 300);
            Object.keys(this.payload).forEach(k => {
                this.payload[k] = note[k];
                if (k === "session_at") {
                    this.payload.session_at = new Date(note.session_at);
                }
            });
        },

        preparePayload() {
            let payload = {};
            if (this.payload.id) {
                payload = { ...this.payload };
            } else {
                payload = { ...this.newPayload };
            }
            if (payload.session_at) {
                payload.session_at = this.moment(payload.session_at).format("YYYY-MM-DD");
                if (!this.moment(payload.session_at)._isValid) {
                    payload.session_at = this.moment().format("YYYY-MM-DD");
                }
            }
            return this.validatePayload(payload);
        },

        validatePayload(payload) {
            let errorMessage = "";
            if (!payload.plan && !payload.subjective && !payload.objective && !payload.assessment) {
                errorMessage += `At least one of the fields 'subjective', 'objective', 'assessment' or 'plan' must be filled.<br>`;
            }
            if (!payload.session_at) {
                errorMessage += `Date must be filled.<br>`;
            }
            if (errorMessage) {
                this.$swal({
                    title: "Error",
                    html: errorMessage,
                    type: "error",
                    confirmButtonText: "Close",
                    confirmButtonColor: "#d64571",
                });
                return null;
            }
            return payload;
        },

        updateNote() {
            let payload = this.preparePayload();
            if (!payload) return;
            axios
                .patch(`/api/patients/${this.patient.id}/soap_notes/${payload.id}`, payload)
                .then(response => {
                    this.resetPayload();
                    this.fetchNotes();
                })
                .catch(e => {
                    let errorObject = _.get(e, "response.data.errors", {});
                    let errorDetails = "";
                    Object.keys(errorObject).forEach(
                        errorKey => (errorDetails += `${errorObject[errorKey]}<br>`)
                    );
                    this.$swal({
                        title: "Error",
                        html: `An error occurred while saving. <br>${errorDetails}`,
                        type: "error",
                        confirmButtonText: "Close",
                        confirmButtonColor: "#d64571",
                    });
                });
        },

        deleteNote(id) {
            axios
                .delete(`/api/patients/${this.patient.id}/soap_notes/${id}`)
                .then(response => {
                    this.fetchNotes();
                })
                .catch(e => {
                    let errorObject = _.get(e, "response.data.errors", {});
                    let errorDetails = "";
                    Object.keys(errorObject).forEach(
                        errorKey => (errorDetails += `${errorObject[errorKey]}<br>`)
                    );
                    this.$swal({
                        title: "Error",
                        html: `An error occurred while deleting. <br>${errorDetails}`,
                        type: "error",
                        confirmButtonText: "Close",
                        confirmButtonColor: "#d64571",
                    });
                });
        },

        fetchNotes() {
            axios.get(`/api/patients/${this.patient.id}/soap_notes`).then(response => {
                this.notes = response.data.data.sort(
                    (a, b) =>
                        this.moment(b.session_at).format("X") -
                        this.moment(a.session_at).format("X")
                ); // Sorts by newest first;
                this.pagination.per_page = 10;
                this.pagination.last_page =
                    Math.floor(this.notes.length / (this.pagination.per_page || 1)) +
                    (this.notes.length % (this.pagination.per_page || 1) ? 1 : 0);
            });
        },

        saveNote() {
            helpers.toggleSpinner("save-note");
            let payload = this.preparePayload();
            if (!payload) {
                helpers.toggleSpinner("save-note");
                return;
            }
            payload.patient_id = this.patient.id;
            payload.created_by_user_id = this.userId;
            axios
                .post(`/api/patients/${this.patient.id}/soap_notes`, payload)
                .then(response => {
                    this.resetPayload();
                    this.fetchNotes();
                    this.$refs.caregiverSignature.cancel();
                    helpers.toggleSpinner("save-note");
                })
                .catch(e => {
                    let errorObject = _.get(e, "response.data.errors", {});
                    let errorDetails = "";
                    Object.keys(errorObject).forEach(
                        errorKey => (errorDetails += `${errorObject[errorKey]}<br>`)
                    );
                    this.$swal({
                        title: "Error",
                        html: `An error occurred while saving. <br>${errorDetails}`,
                        type: "error",
                        confirmButtonText: "Close",
                        confirmButtonColor: "#d64571",
                    });
                    helpers.toggleSpinner("save-note");
                });
        },

        caregiverSignatureCancelled() {
            this.newPayload.caregiver_signature = null;
        },

        caregiverSignatureCreated(signature_url) {
            this.newPayload.caregiver_signature = signature_url;
        },
    },
};
</script>

<style scoped lang="scss">
.data-row {
    border: solid 1px #8f8f8f;
    border-bottom: none;
}
.data-row:last-child {
    border: solid 1px #8f8f8f;
}
#soap_chart .row {
    background: white;
    .picker-container {
        padding-left: 0px;
    }
}
</style>
